import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React, { useContext } from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../../../Seatbelt2/Foundations/Typography'
import { Context as TableContext } from '../../Table.context'
import styles from './Cell.module.scss'
import { getAlignment, sizeClassMap } from './Cell.utils'

export const Cell: FunctionComponent<Props> = ({
  index = 0,
  align = 'auto',
  colSpan = 1,
  rowSpan = 1,
  children,
  ...rest
}) => {
  const tableContextValue = useContext(TableContext)
  const alignment = getAlignment({ align, children })

  return (
    <td
      colSpan={colSpan}
      rowSpan={rowSpan}
      className={classnames(
        styles.container,
        tableContextValue.sizing &&
          sizeClassMap.get(tableContextValue.sizing[index]),
        alignment === 'left' && styles.containerAlignLeft,
        alignment === 'right' && styles.containerAlignRight,
        alignment === 'centre' && styles.containerAlignCentre
      )}
      {...rest}
    >
      <TypographyV2 tag="span" textStyle="sb-text-interface-body-small-regular">
        {children}
      </TypographyV2>
    </td>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Optional index number
   */
  index?: number
  /**
   * Optional string for to set alignment
   */
  align?: Align
  /**
   * Optional number for how many columns to span
   */
  colSpan?: number
  /**
   * Optional number for how many rows to span
   */
  rowSpan?: number
  /**
   * Children to render
   */
  children: ReactNode
} & HTMLProps<HTMLTableCellElement>

export type Align = 'auto' | 'left' | 'right' | 'centre'
